import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/creators/{creatorSlug}/routable/company/{companyId}';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getRoutableCompany = async ({ companyId, creatorSlug }: Input ): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { companyId, creatorSlug });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getRoutableCompany;
